module.exports = __webpack_public_path__ + "img/신현리 네일샵.6ce63fc7.png";